import { DeviceMode } from "app/models/enums.model";

export class INFO {
    availableCommands : any[];
    Type: string = 'INFO';
    centralConnected: boolean;
    ipaddress: string;
    mac: string;
    processor: string;
    sn: string;
    deviceType: string;
    version: string;
    type: string;
    currentMode: DeviceMode;
}
